import { createSelector } from "reselect";
import _ from "lodash";
const createSelectors = parentReducer => {
    
    return new class {
        selectAllUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackAssigneesArrayListWidget_reducer"];
            return reducer.users;
        };
        selectAllAreas = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackAssigneesArrayListWidget_reducer"];
            return reducer.areas;
        };
        selectAllDepartments = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackAssigneesArrayListWidget_reducer"];
            return reducer.departments;
        };
        selectProfile = store => {
            const reducer =
                store["UserProfile_reducer"];
                let userInfo = reducer.user;
            return userInfo.profile;
        };

        selectDept = createSelector (
            [this.selectProfile],
            
            (profile = false) => {
                if(profile)
                {
                    return profile.departments
                }
                else return null
            }
        )
        selectAreas = createSelector (
            [this.selectProfile],
            (profile = false) => {
                if(profile)
                {
                    return profile.areas
                }
                else return null
            }
        )
        selectUserInfo = createSelector(
            [this.selectAllUsers, this.selectAllAreas, this.selectAllDepartments, this.selectAreas, this.selectDept],
            (users = false, allAr = false, allDept = false,userAreas = false, userDepts = false ) => {
                let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
                let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
                if(userAreas === false)
                {
                    userAreas = allAreas
                }
                if(userDepts === false)
                {
                    userDepts = allDepartments
                }
                let validationArea = []
                let validationDept = []
                if (users) {
                    let userInfo = _.compact(
                        Object.keys(users).map(e => {
                            let refArray = []
                            let uid = e;
                            let fname =
                                _.get(users[e], "profile.first_name") || "N/A";
                            let lname =
                                _.get(users[e], "profile.last_name") || "N/A";
                            let deleted =
                                _.get(users[e], "profile.deleted") || false;
                            let areas = 
                                _.get(users[e], "profile.areas") || null
                            let departments = 
                                _.get(users[e], "profile.departments") || null 

                            if(userAreas === [])
                            {

                            }
                            if(areas === null )
                            {
                                
                                validationArea = _.intersection(allAreas,userAreas)
                            }
                            
                            else{
                                validationArea = _.intersection(areas,userAreas)
                            }
                            if(departments === null)
                            {
                                
                                validationDept = _.intersection(allDepartments,userDepts)
                                
                            }
                            else {
                                validationDept = _.intersection(departments,userDepts)
                            } 
                                if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                                    refArray.push({ uid, user_name: `${fname} ${lname}` })
                                    return { uid, user_name: `${fname} ${lname}` };
                                        
                                } else return null;
                        })
                    );

                    // let userInfoDept = _.compact(
                    //     Object.keys(users).map(e => {
                    //         let uid = e;
                    //         let fname =
                    //             _.get(users[e], "profile.first_name") || "N/A";
                    //         let lname =
                    //             _.get(users[e], "profile.last_name") || "N/A";
                    //         let deleted =
                    //             _.get(users[e], "profile.deleted") || false;
                    //         let departments = 
                    //             _.get(users[e], "profile.departments") || null
                    //         let validationDept = _.intersection(departments,userDepts)
                    //             if (!deleted && validationDept.length !== 0) {
                                    
                    //                 return { uid, user_name: `${fname} ${lname}` };
                                        
                    //             } else return null;
                    //     })
                    // );

                    
                    // //code to merge two array of objects
                    // Array.prototype.push.apply(userInfo,userInfoDept); 
                    // //code to remove duplicates from array of objects
                    // let finalUsers = userInfo.filter((v,i,a)=>a.findIndex(t=>(t.uid === v.uid))===i)
                    return userInfo.sort((a, b) => a.user_name.localeCompare(b.user_name));
                } else return false;
            }
        );
    }();
};



export default createSelectors;